import React from 'react';
import { Layout, Avatar, Dropdown, Space, Typography, message, Tag } from 'antd';
import { UserOutlined, LogoutOutlined, BellOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useNavigate } from 'react-router-dom';
import { APP_CONFIG } from '../../config';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header: React.FC = () => {
  const navigate = useNavigate();
  
  const handleMenuClick: MenuProps['onClick'] = ({ key }) => {
  
      if (key === 'logout') {
  
        // 清除本地存储
  
        localStorage.removeItem(APP_CONFIG.tokenKey);

        localStorage.removeItem(APP_CONFIG.refreshTokenKey);

        localStorage.removeItem(APP_CONFIG.userKey);

        message.success('已退出登录');

        window.location.href = '/login';
  
      } else if (key === 'profile') {
  
        message.info('个人资料功能开发中...');
  
      }
  
    };

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      label: '个人资料',
      icon: <UserOutlined />,
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      label: '退出登录',
      icon: <LogoutOutlined />,
      danger: true,
    },
  ];

  // 获取用户信息
  const userStr = localStorage.getItem(APP_CONFIG.userKey);
  const user = userStr ? JSON.parse(userStr) : null;
  const adminName = user?.nickname || user?.phone || '管理员';
  const isSuperAdmin = user?.isSuperAdmin;

  return (
    <AntHeader style={{ 
      padding: '0 24px', 
      background: '#fff',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      boxShadow: '0 1px 4px rgba(0,21,41,.08)',
      marginLeft: 200 // 为侧边栏留出空间
    }}>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <Text strong style={{ fontSize: '16px', color: '#262626' }}>
          甄来电小程序后台管理系统
        </Text>
        {isSuperAdmin && (
          <Tag color="red" style={{ marginLeft: 12 }}>超级管理员</Tag>
        )}
      </div>
      
      <Space size="middle">
        <BellOutlined style={{ fontSize: '18px', color: '#666', cursor: 'pointer' }} />
        
        <Dropdown
          menu={{ items: userMenuItems, onClick: handleMenuClick }}
          placement="bottomRight"
          arrow
        >
          <Space style={{ cursor: 'pointer' }}>
            <Avatar size="small" icon={<UserOutlined />} />
            <Text>{adminName}</Text>
          </Space>
        </Dropdown>
      </Space>
    </AntHeader>
  );
};

export default Header;
